import { render } from "./ToggleButton2.vue?vue&type=template&id=6442c46f&scoped=true"
import script from "./ToggleButton2.vue?vue&type=script&lang=js"
export * from "./ToggleButton2.vue?vue&type=script&lang=js"

import "./ToggleButton2.vue?vue&type=style&index=0&id=6442c46f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6442c46f"]])

export default __exports__